import Vue from 'vue';
import App from './App.vue';

import store from "@/store";
import router from "@/router";
import mountI18n from "@/plugins/i18n";
import BreakpointsObserverPlugin from "@/plugins/breakpointsObserver";

import AppIcon from "@/components/common/AppIcon/AppIcon.vue";

import api from "@/api";

import VClickOutside from "v-click-outside";
import Vue2TouchEvents from 'vue2-touch-events'
import VueSplide from "@splidejs/vue-splide"

import 'mapbox-gl/dist/mapbox-gl.css';
import '@splidejs/splide/dist/css/splide.min.css';
import '@/assets/styles/index.scss';

import appBreakpoints from "@/config/appBreakpoints";

import "@/helpers/defineCssThemeVariables";

Vue.component('AppIcon', AppIcon)

Vue.prototype.$api = api

Vue.use(VClickOutside)
Vue.use(Vue2TouchEvents)
Vue.use(VueSplide)
Vue.use(BreakpointsObserverPlugin, { breakpoints: appBreakpoints })

Vue.config.productionTip = false

mountI18n()
  .then((i18n) => {
    new Vue({
      store,
      router,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  })
